import { useState } from 'react';
import { Item } from '../../../mechanics/items/Item';
import { upgradeItem } from '../../../controllers/itemUpgradeController';
import { sceneSlice } from '../../../store/reducers/SceneReducer';
import { useAppDispatch, useAppSelector } from '../../../store/store';
import BaseButton from '../../ui/BaseButton';
import './CampEquipmentUpgrade.scss'
import ImgWithFallback from '../../ui/ImgWithFallback';

const CampEquipmentUpgrade = () => {
    // redux const
    const dispatch = useAppDispatch()
    const { setScene } = sceneSlice.actions
    const mainCharacter = useAppSelector(state => state.userReducer.character)
    // state const
    const [chosenItem, setChosenItem] = useState<Item | null>(null)
    const [render, setRender] = useState(false)
    // other const
    const characterCurrensies = mainCharacter.getInventory().getCurrensies()
    const characterEquipment = mainCharacter.getEquipment()
    const characterInventoryEquipment = mainCharacter.getInventory().getItems().filter(item => item.getType() !== 'potion')

    const backClick = () => {
        dispatch(setScene("camp"))
    }

    const handleChoice = (item: Item) => {
        setChosenItem(item)
    }

    const upgrade = (item: Item) => {
        upgradeItem(item, mainCharacter)
        setRender(!render)
    }

    return (
        <div className='camp-equipment component'>
            <div className="camp-equipment__wrapper">
                <h1 className="camp-equipment__tite component-title">Equipment upgrade</h1>
                <div className="camp-equipment__content">
                    <div className="camp-equipment__content-column">
                        <div className="currensy">
                            <h2 className="currensy__title">Amount currensy</h2>
                            <ul className="currensy__list">
                                {Object.values(characterCurrensies).map(item => {
                                    return (
                                        <li className="currensy__list-item" key={crypto.randomUUID()}>
                                            <ImgWithFallback
                                                src={item.images.webp}
                                                fallbackSrc={item.images.img}
                                                alt={item.name} />
                                            <span>{item.amount}</span>
                                        </li>
                                    )
                                })}
                            </ul>
                        </div>
                    </div>
                    <div className="camp-equipment__content-column">
                        <div className="equipment">
                            <div className="equipment__block">
                                <h2 className="equipment__block-title">Equipped</h2>
                                <ul className="equipment__block-list">
                                    {Object.values(characterEquipment).map((item: Item) => {
                                        return (
                                            <li
                                                className="equipment__block-item adaptive-img-cover"
                                                key={crypto.randomUUID()}
                                                onClick={() => handleChoice(item)}
                                            >
                                                <ImgWithFallback src={item.getImg().webp} fallbackSrc={item.getImg().img} />
                                            </li>
                                        )
                                    })}
                                </ul>
                            </div>
                            <div className="equipment__block">
                                <h2 className="equipment__block-title">Other</h2>
                                <ul className="equipment__block-list">
                                    {characterInventoryEquipment.map((item: Item) => {
                                        return (
                                            <li
                                                className="equipment__block-item adaptive-img-cover"
                                                key={crypto.randomUUID()}
                                                onClick={() => handleChoice(item)}
                                            >
                                                <ImgWithFallback src={item.getImg().webp} fallbackSrc={item.getImg().img} />
                                            </li>
                                        )
                                    })}
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="camp-equipment__content-column prewiew">
                        <h2 className="prewiew__title">Chosen item</h2>
                        <div className="prewiew__body">
                            {!chosenItem ?
                                (<div className='prewiew__body-not-chosen'><p>Chose item</p></div>)
                                :
                                <div className='prewiew__body-content'>
                                    <div className="prewiew__body-columns">
                                        <div className='current-item__body'>
                                            <p className='current-item__body-name'>{chosenItem.getName()}</p>
                                            <ImgWithFallback
                                                classNames={'current-item__body-img'}
                                                src={chosenItem.getImg().webp}
                                                fallbackSrc={chosenItem.getImg().img}
                                                alt={chosenItem.getName()} />
                                            {
                                                chosenItem.getArmorValue() ?
                                                    (<p className='current-item__body-value'>Armor value: {chosenItem.getArmorValue()}</p>)
                                                    :
                                                    (<p className='current-item__body-value'>Damage value: {chosenItem.getWeaponDamage()}</p>)
                                            }
                                        </div>
                                        <i>
                                            <svg
                                                width="48"
                                                height="48"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M15.0378 6.34317L13.6269 7.76069L16.8972 11.0157L3.29211 11.0293L3.29413 13.0293L16.8619 13.0157L13.6467 16.2459L15.0643 17.6568L20.7079 11.9868L15.0378 6.34317Z"
                                                    fill="currentColor"
                                                />
                                            </svg>
                                            <div className="prewiew__body-cost">
                                                <p>{chosenItem.getItemLvl().itemToLvlUpAmount}</p>
                                                <ImgWithFallback
                                                    src={chosenItem.getItemLvl().itemToLvlUpImg.webp}
                                                    fallbackSrc={chosenItem.getItemLvl().itemToLvlUpImg.img}
                                                    alt={chosenItem.getItemLvl().itemToLvlUpName} />
                                            </div>
                                        </i>
                                        <div className='preview-upg-item__body'>
                                            <p className='preview-upg-item__body-name'>{chosenItem.getName()}</p>
                                            <ImgWithFallback
                                                classNames='preview-upg-item__body-img'
                                                src={chosenItem.getImg().webp}
                                                fallbackSrc={chosenItem.getImg().img}
                                                alt={chosenItem.getName()} />
                                            {chosenItem.getArmorValue() ?
                                                (<p className='preview-upg-item__body-value'>Armor value: {chosenItem.getArmorValue() + 1}</p>)
                                                :
                                                <p className='preview-upg-item__body-value'>Damage value: {chosenItem.getWeaponDamage() + 1}</p>
                                            }
                                        </div>
                                    </div>
                                    <BaseButton name={'Upgrade'} onClick={() => upgrade(chosenItem)} className={'prewiew__body-btn'} />
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <BaseButton name='Back' onClick={backClick} />
            </div>
        </div>
    );
};

export default CampEquipmentUpgrade;